module.exports = __webpack_public_path__ + "img/demo2.dfe033a2.jpg";